(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ev-resenas-compra"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ev-reviews-carousel')) {
    customElements.define('ev-reviews-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const slides = Array.from(this.querySelectorAll('[data-ev-review]'));
        const dots = Array.from(this.querySelectorAll('[data-ev-review-dot]'));
        if (!slides.length) return;
        let active = 0;
        const show = (index) => {
          active = (index + slides.length) % slides.length;
          slides.forEach((slide, i) => { slide.hidden = i !== active; });
          dots.forEach((dot, i) => { dot.setAttribute('aria-current', String(i === active)); });
        };
        dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          show(active + (event.key === 'ArrowRight' ? 1 : -1));
          if (dots[active]) dots[active].focus();
        });
        let touchX = 0, touchY = 0;
        this.addEventListener('touchstart', (event) => {
          if (event.touches.length !== 1) return;
          touchX = event.touches[0].clientX;
          touchY = event.touches[0].clientY;
        }, { passive: true });
        this.addEventListener('touchend', (event) => {
          if (!event.changedTouches.length) return;
          const dx = event.changedTouches[0].clientX - touchX;
          const dy = event.changedTouches[0].clientY - touchY;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) show(active + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
